<template>
  <!-- 产品报价弹窗 -->
  <div>
    <a-drawer
      :title="title"
      :maskClosable="true"
      :width="800"
      placement="right"
      :closable="true"
      @close="handleCancel"
      :visible="visible"
      style="overflow: auto; padding-bottom: 53px"
    >
      <a-spin :spinning="comfirmLoading">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="产品名称" prop="fundName">
            <a-input v-model="form.fundName" :disabled="disabled"></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="起息日"
            prop="startValue"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-date-picker
              v-model="form.startValue"
              :disabled-date="disabledStartDate"
              format="YYYY-MM-DD "
              placeholder="请选择起息日"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            prop="endValue"
            label="结息日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-date-picker
              v-model="form.endValue"
              :disabled-date="disabledEndDate"
              format="YYYY-MM-DD "
              placeholder="请选择结息日"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            label="预期开放日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="openDate"
          >
            <j-date
              placeholder="请输入预期开放日"
              v-model="form.openDate"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            prop="expectedYield"
            label="收益率"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-model="form.expectedYield"
              placeholder="请输入收益率"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item
            label="申购日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="purchaseDate"
          >
            <j-date
              placeholder="请选择申购日期"
              v-model="form.purchaseDate"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            label="赎回日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="redemptionDate"
          >
            <j-date
              placeholder="请选择赎回日期"
              v-model="form.redemptionDate"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            label="下一个申购日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <j-date
              placeholder="请选择下一个申购日"
              v-model="form.nextPurchaseDate"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            label="下一个赎回日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <j-date
              placeholder="请选择下一个赎回日"
              v-model="form.nextRedemptionDate"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item
            label="下一个开放日"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <j-date
              placeholder="请选择下一个开放日"
              v-model="form.nextOpenDate"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
      <div class="drawer-bootom-button">
        <a-popconfirm
          title="确定放弃编辑？"
          @confirm="handleCancel"
          okText="确定"
          cancelText="取消"
        >
          <a-button style="margin-right: 0.8rem">取消</a-button>
        </a-popconfirm>
        <a-button @click="handleOk" type="primary">提交</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { postAction, httpAction, jsonAction } from '../../../../api/manage';
let productParticulars = JSON.parse(
  sessionStorage.getItem('productParticulars')
);
export default {
  data() {
    return {
      rules: {
        fundName: [
          {
            required: true,
            message: '产品名称不能为空',
          },
        ],
        startValue: [
          {
            required: true,
            message: '请选择起息日',
          },
        ],
        endValue: [
          {
            required: true,
            message: '请选择结息日',
          },
        ],
        openDate: [
          {
            required: true,
            message: '请选择预期开放日',
          },
        ],
        expectedYield: [
          {
            required: true,
            message: '请输入收益率',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: '请选择申购日',
          },
        ],
        redemptionDate: [
          {
            required: true,
            message: '请选择赎回日',
          },
        ],
      },
      visible: false,
      comfirmLoading: false,
      startValue: null, //开始时间
      endValue: null, //结束时间
      title: '产品报价新增',
      fundName: '',
      productParticulars, //当前产品的所有数据
      disabled: true,
      width: 1200,
      form: {
        fundName: '',
        startValue: undefined,
        endValue: undefined,
        expectedYield: '', //收益率
        nextOpenDate: '', //下一个开放日
        nextPurchaseDate: '', //下一个申购日
        nextRedemptionDate: '', //下一个赎回日
        purchaseDate: '', //申购日
        redemptionDate: '', //赎回日
        openDate: '', //预期开放日
      },
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      url: {
        add: process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/add',
        edit:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/edit',
      },
    };
  },
  components: {
    JDate,
  },
  watch: {
    startValue(val) {
      console.log(val);
    },
    endValue(val) {
      console.log(val);
    },
  },
  methods: {
    // 选择开始时间后禁止结束时间超过前面的时间
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },

    //新增弹窗
    add() {
      let productParticular = JSON.parse(
        sessionStorage.getItem('productParticulars')
      );
      this.visible = true;
      this.startValue = null;
      this.endValue = null;
      this.form = {};
      this.fundName = productParticular.fundName;
      this.form.fundName = productParticular.fundName;
    },
    //修改
    edit(record) {
      this.visible = true;
      this.startValue = record.beginDate;
      this.endValue = record.endDate;
      let productParticular = JSON.parse(
        sessionStorage.getItem('productParticulars')
      );
      console.log(record);
      this.form = Object.assign({}, record);
      this.fundName = productParticular.fundName;

      this.form = {
        ...this.form,
        startValue: record.beginDate,
        endValue: record.endDate,
        fundName: productParticular.fundName,
      };
    },

    handleOk() {
      // 触发表单验证
      this.$refs.ruleForm.validate((vaild, values) => {
        console.log(vaild, this.form, values);
        if (vaild) {
          let that = this;
          that.comfirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.form.id) {
            httpurl += that.url.add;
            method = 'POST';
          } else {
            httpurl += that.url.edit;
            method = 'POST';
          }
          that.form.fundCode = this.$route.query.fundCode;
          if (this.form.startValue == null) {
            that.form.beginDate = '';
          } else {
            that.form.beginDate = moment(this.form.startValue).format(
              'YYYY-MM-DD'
            );
          }
          if (this.form.endValue == null) {
            that.form.endDate = '';
          } else {
            that.form.endDate = moment(this.form.endValue).format('YYYY-MM-DD');
          }
          // console.log(moment(this.startValue).format('YYYY-MM-DD'));
          let formData = Object.assign(that.form, values);
          jsonAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', formData);
              that.comfirmLoading = false;
              this.handleCancel();
            } else {
              that.$message.warning(res.message);
              that.comfirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.$emit('close');
      this.visible = false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
